import PropTypes from 'prop-types';
import CssClassMixin from '../../mixins/css_class_mixin.jsx';
import InputComponentMixin from '../../mixins/input/input_component_mixin.jsx';

var createClass = require('create-react-class');

window.InputTextarea = createClass({
  mixins: [CssClassMixin, InputComponentMixin],
  propTypes: {
    rows: PropTypes.number
  },

  getDefaultProps: function() {
    return {
      rows: 4,
      themeClassKey: 'input.textarea'
    };
  },

  render: function() {
    return (
      <textarea {...this.props}
        value={this.state.value}
        placeholder={this.getPlaceholder()}
        className={this.inputClassName()}
        onChange={this._handleChange}
        onFocus={this._handleFocus}
        ref="input"
      />
    );
  }
});
